import bannerImg from '../../assets/images/refer-banner.png'

const ReferalBanner = () => {
  return (
    <div className="row mt-4">
            <div className="col-lg-12">
                <div className="referal_banner position-relative">
                    <img src={bannerImg} className='img-fluid' alt="" />
                    <h1>Refer a Friend</h1>
                    <p>You can refer multiple friends from different countries</p>
                </div>
            </div>
        </div>
  )
}

export default ReferalBanner